import React from "react";
import styled from "styled-components";

import { useScrollAnimation } from "../../hooks/useScrollAnimation";

const Wrapper = styled.div`
  opacity: ${(props) => (props.$on ? 1 : 0)};
  transform: translateY(${(props) => (props.$on ? "0px" : "24px")});
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
`;

// Fades its children up the first time they scroll into view.
function Reveal(props) {
  const { ref, isVisible } = useScrollAnimation({
    threshold: 0.1,
    rootMargin: "0px 0px -5% 0px",
    triggerOnce: true,
    delay: props.delay || 0,
  });

  return (
    <Wrapper ref={ref} $on={isVisible} className={props.className}>
      {props.children}
    </Wrapper>
  );
}

export default Reveal;
